// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1qV4O","content":"styles_content__jrm0I","checkbox":"styles_checkbox__3PMKp","checkboxLabel":"styles_checkboxLabel__3arOA"};